export class WebhookV1StandardPayloadResourceArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "resourceArguments",
            "baseName": "resourceArguments",
            "type": "WebhookV1ResourceArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadResourceArguments.attributeTypeMap;
    }
    constructor() {
    }
}
